module.exports = __webpack_public_path__ + "img/nj-LOGO.2a1a727a.png";